import { FC } from 'react';

import { Box, InformationCircleSolid, StyleProps, Text, Tooltip } from '@bonusly/design-system';

import { useNotationText } from './feedback/hooks/use-notation-text';

interface ActionNotationProps extends StyleProps {
	isVisible?: boolean;
}

export const ActionNotation: FC<ActionNotationProps> = ({ isVisible = true }) => {
	const text = useNotationText();

	if (!text) {
		return null;
	}

	return (
		<Box
			alignItems="center"
			color="gray.500"
			display="flex"
			gap={1}
			p={2}
			visibility={isVisible ? 'visible' : 'hidden'}
			_hover={{ color: 'gray.700' }}
			position="relative"
			bottom={0}
		>
			<Tooltip label={text.required} openDelay={500} hasArrow placement="top" bg="gray.700">
				<Box display="flex" gap={1} alignItems="center">
					<InformationCircleSolid size="sm" />
					{text.optional && (
						<Text fontSize="sm" fontWeight="normal" lineHeight="short">
							{text.optional}
						</Text>
					)}
				</Box>
			</Tooltip>
		</Box>
	);
};
